import ServicePage from '../servicePage/ServicePage';
import { platformIntegrationServiceData } from '../../data/platformIntegrationServiceData';

const PlatformIntegrationPage = () => {
  return <ServicePage serviceData={platformIntegrationServiceData} />;
};

export default PlatformIntegrationPage;